import type { Method } from '@piccolohealth/pbs-common';
import type { SelectOption } from '@piccolohealth/ui';
import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';

export type MethodType = NonNullable<Method['__typename']>;

export const methodOptions: Record<MethodType, SelectOption<MethodType>> = {
  AbcMethod: {
    label: 'ABC',
    value: 'AbcMethod',
    raw: 'AbcMethod',
    color: 'blue',
  },
  DurationMethod: {
    label: 'Duration',
    value: 'DurationMethod',
    raw: 'DurationMethod',
    color: 'yellow',
  },
  EpisodicSeverityMethod: {
    label: 'Episodic Severity',
    value: 'EpisodicSeverityMethod',
    raw: 'EpisodicSeverityMethod',
    color: 'green',
  },
  FrequencyMethod: {
    label: 'Frequency',
    value: 'FrequencyMethod',
    raw: 'FrequencyMethod',
    color: 'red',
  },
} as const;

interface Props extends ChakraV3.TagProps {
  method: Pick<Method, '__typename'>;
}

export const MethodTag = (props: Props) => {
  const { method, ...rest } = props;

  const option = methodOptions[method.__typename ?? 'FrequencyMethod'];

  return (
    <ChakraV3.Tag size='sm' colorPalette={option.color} {...rest}>
      {option.label}
    </ChakraV3.Tag>
  );
};
